<template>
  <v-container class="mt-12 pt-8" style="background:#fafafa;">
    <v-row style="background:#fafafa;" :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" md="6" >
                <Item :item="data" :statuses="statuses" :payment_methods="payment_methods" :extend="true" :loading="loading" @reloadData="reload" />
              </v-col>
              <v-col cols="12" md="6" v-if="data && data.items && data.items.length">
                <v-row no-gutters>
                  <v-col cols="12" v-if="!data.items[0].accepted_quotation && !data.items[0].rejected_quotation && data.items[0].quotation_price && data.items[0].quotation_quantity">
                    <POQuoteAnswer :po="data" :rejection_reasons="rejection_reasons" :payment_methods="payment_methods" @reloadData="reload" :loading="loading" />
                  </v-col>
                  <v-col cols="12" v-if="data.items[0].accepted_quotation">
                    <v-card :loading="loading">
                      <v-alert
                        border="bottom"
                        type="success"
                      >{{ i18n["price_quotation_accepted"] }}
                      <div class="mt-6">{{i18n["current_po_status"]}}</div>
                      <div style="font-weight:28px;font-weight:bold;">{{i18n[data.items[0].status.label]}}</div>
                      <div class="mt-6">{{i18n["last_update"]}}</div>
                      <div>{{ i18n[data.items[0].updates[0].update.split('|')[0]]}}</div>
                      </v-alert>
                    </v-card>
                  </v-col>
                  <v-col cols="12" v-if="data.items[0].rejected_quotation">
                    <v-card :loading="loading">
                      <v-alert
                        border="bottom"
                        type="error"
                      >{{ i18n["rejected_quotation_successfully"] }}
                      <div class="mt-6">{{i18n["rejected_reason"]}}</div>
                      <div style="font-weight:28px;font-weight:bold;">{{i18n['reject_' + data.items[0].rejected_reason]}}</div>
                      <div class="mt-6">{{i18n["rejected_reason_details"]}}</div>
                      <div>{{ data.items[0].rejected_reason_details}}</div>
                      </v-alert>
                    </v-card>
                  </v-col>
                  <v-col cols="12" v-if="data.items[0].accepted_quotation && data.items[0].wholesale_status_id < 5 && data.payment_method">
                    <v-card :loading="loading">
                      <v-card-title>
                        {{i18n["payment_method"]}}
                      </v-card-title>
                      <v-card-text>
                        <div>
                          {{i18n["po_" + data.payment_method.label]}}
                        </div>
                        <div v-html="data.payment_method.details"></div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" class="pt-2">
                    <Conversation :po="data" @reloadData="reload" :loading="loading" />
                  </v-col>
                </v-row>
              </v-col>
              
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Conversation from './Conversation.vue'
import Item from './Item.vue'
import POQuoteAnswer from './POQuoteAnswer.vue'
export default {
  components: {
    Item,
    POQuoteAnswer,
    Conversation,
	},
  data() {
    return {
      loading: false,
      data: null,
      rejection_reasons:[],
      payment_methods:[],
      statuses:[],
    }
  },
  methods: {
    async showPage() {
      this.loading = true
      let poData = await this.$store.dispatch('getResource', { resource: `/purchase-orders/${this.$route.params.page}` })
      console.log(poData)
      this.data = poData.data
      this.rejection_reasons = poData.rejection_reasons.map(x=>{return {value:x, text:this.i18n['reject_' + x]}})
      this.payment_methods = poData.payment_methods.map(x=>{return {value:x.id, text:this.i18n['po_' + x.label], ...x}})
      this.statuses = poData.statuses.map(x=>{return {value:x.id, text:this.i18n['po_' + x.label], ...x}})
      this.loading = false
    },
    async reload(){
      console.log('rel')
      await this.showPage()
    }
  },
  watch: {
    '$route.params.page': {
      async handler(value) {
        await this.showPage()
      }
    }
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
  },
  async mounted() {
    await this.showPage()
  },
}
</script>

<style>
.ql-page h1,
.ql-page h2,
.ql-page h3,
.ql-page h4,
.ql-page h5,
.ql-page h6,
.ql-page p,
.ql-page span
{
  line-height: 1.5;    
}

.ql-page img {
  width:100%;
}
</style>